import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { PublisherUser } from '../../../../../../models/publisher-user';
import { PublisherUserService } from '../../../../../../services/publisher-user.service';
import { Helpers } from '../../../../../../helpers';
import { BaseComponent } from '../../../base.component';
import { UserGroupService } from '../../../../../../services/user-group.service';
import { PublisherDetailTab } from '../../../owner/publisher-detail/publisher-detail.component';
import { DataService } from '../../../../../../_services/data.service';
import { Paths } from '../../../../../../models/enums';

@Component({
    selector: 'app-publisherUser',
    templateUrl: './create-publisherUser.component.html',
    encapsulation: ViewEncapsulation.None
})
export class CreatePublisherUserComponent extends BaseComponent
    implements OnInit {
    publisherUser: PublisherUser = new PublisherUser();
    userGroups: any[] = [];
    returnUrl: string;
    publisherName: string;

    constructor(
        private publisherUserService: PublisherUserService,
        private userGroupService: UserGroupService,
        private router: Router,
        private route: ActivatedRoute,
        private dataService: DataService
    ) {
        super();
        this.publisherUser.publisherId = route.snapshot.queryParams.publisherId;
        this.returnUrl = route.snapshot.queryParams.returnUrl;
        this.publisherName = route.snapshot.queryParams.publisherName;
        this.buildBreadcrumb(route);
    }

    buildBreadcrumb(route) {
        route.snapshot.parent.data.url = '/' + this.returnUrl;
        if (this.dataService.path == Paths.Owner) {
            route.snapshot.parent.data.queryParams = {
                tab: PublisherDetailTab.User,
                name: this.publisherName
            };
            route.snapshot.parent.parent.data.url = '/' + this.returnUrl;
            route.snapshot.parent.parent.data.breadcrumb = this.publisherName;
            route.snapshot.parent.parent.data.queryParams = {
                name: this.publisherName
            };
        }
    }

    ngOnInit() {
        this.initPhoneMasks();
        this.getUserGroups();
    }

    initPhoneMasks() {
        (<any>$('#phone')).inputmask({
            mask: '(999) 999 9999'
        });
    }

    getUserGroups() {
        this.userGroupService
            .list({ filterId: this.publisherUser.publisherId })
            .subscribe(res => {
                this.userGroups = res.data;
            });
    }

    navigate() {
        let queryParams = {};
        if (this.dataService.path == Paths.Owner) {
            queryParams['name'] = this.publisherName;
            queryParams['tab'] = PublisherDetailTab.User;
        }
        this.router.navigate([this.returnUrl], {
            queryParams: queryParams
        });
    }

    validate(event) {
        var customRules = this.validationService.customRules;
        return this.validationService.validate(event, {
            rules: {
                firstName: customRules.requiredText,
                lastName: customRules.requiredText,
                email: customRules.requiredEmail,
                password: customRules.requiredText,
                userGroupId: { required: true }
            }
        });
    }

    createPublisherUser() {
        var _self = this;
        Helpers.setLoading(true);
        this.publisherUser.cellPhone = (<any>$('#phone')).val();
        this.publisherUserService.create(this.publisherUser).subscribe(() => {
            Helpers.setLoading(false);
            this.swalService.successCreate();
            setTimeout(function() {
                _self.navigate();
            }, 1000);
        });
    }
}



// WEBPACK FOOTER //
// /Users/creative/Documents/GitHub/makrooreservation/src/ui/src/app/theme/pages/default/shared/publisher-user/create-publisher-user/create-publisherUser.component.ts